<template>
  <div>
    <Navbar />
    <SlideShow />
    <AboutUs />
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/shared/Navbar.vue";
import SlideShow from "@/components/shared/SlideShow.vue";
import AboutUs from "@/components/about/AboutUs.vue";
import Footer from "@/components/shared/Footer.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    SlideShow,
    AboutUs,
    Footer
  }
};
</script>
